import { sessionUserSchema } from '@oefy/contracts';
import type { SessionUser } from '@oefy/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { ApiError, api } from '../lib/api';
import { leaveWithoutAsking } from '../lib/navigation';

export const sessionQueryKey = ['session'] as const;

async function fetchSession(): Promise<SessionUser | null> {
  try {
    return await api.get('/auth/session', sessionUserSchema);
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) {
      return null;
    }
    throw error;
  }
}

export function useSession() {
  return useQuery({ queryKey: sessionQueryKey, queryFn: fetchSession, staleTime: 5 * 60_000 });
}

export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: () => api.command('DELETE', '/auth/session'),
    onSettled: () => {
      queryClient.clear();
      void navigate('/inloggen', { replace: true, state: leaveWithoutAsking });
    },
  });
}

export function safeReturnPath(value: string | null): string | null {
  return value?.startsWith('/') && !value.startsWith('//') ? value : null;
}
